// src/App.js
import { Routes, Route } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';

import Header from './components/Header';
import LoadForm from './components/LoadForm';
import ControlPanel from './components/ControlPanel';

import { CarrierProvider, useCarrier } from './context/CarrierContext';
import { carrierThemes } from './themes';

// ---- Inner app that CAN consume context ----
const AppContent = () => {
  const { carrierId } = useCarrier();
  const theme = carrierThemes[carrierId] || carrierThemes.interfreight;

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<LoadForm />} />
          <Route path="/control-panel" element={<ControlPanel />} />
        </Routes>
      </main>
    </ThemeProvider>
  );
};

const App = () => {
  return (
    <CarrierProvider>
      <AppContent />
    </CarrierProvider>
  );
};

export default App;
